import {
  FETCHING_STREAMS,
  FETCHING_STREAMS_SUCCEEDED,
  FETCHING_STREAMS_FAILED,
} from "constants/actionTypes";

import axios from "axios";
import buildUrl from "build-url";
import { createAction } from "redux-actions";
import { call, put, takeLatest } from "redux-saga/effects";

const API_URL = process.env.REACT_APP_API_URL;
const STREAMS_BASE_URL = `${API_URL}/api/1.0/streams`;

/** download reports */
export const fetchStreams = createAction(FETCHING_STREAMS);
const fetchingStreamsSucceeded = createAction(FETCHING_STREAMS_SUCCEEDED);
const fetchingStreamsFailed = createAction(FETCHING_STREAMS_FAILED);

function* fetchStreamsSaga(action) {
  let { account, limit } = action.payload;

  let url = buildUrl(STREAMS_BASE_URL, { path: `/search` });
  const fetchStreamsAPI = () => {
    return axios({
      method: "POST",
      url: url,
      data: { account, limit },
    }).then((response) => response.data);
  };

  try {
    const response = yield call(fetchStreamsAPI);
    yield put(fetchingStreamsSucceeded(response));
  } catch (error) {
    yield put(fetchingStreamsFailed(error));
  }
}

export default function* streamsSaga() {
  yield takeLatest(FETCHING_STREAMS, fetchStreamsSaga);
}
